import { useQuery } from "@tanstack/react-query";
import { getKubeService } from "../../backend";
import { DEPLOYED_APPS_STALE_TIME } from "../../utils/preview-constants";
import type { DeployedAppInfo } from "../../types/preview-environments";

// ─── Query key factory ───────────────────────────────────────────────────────

export const previewKeys = {
    all: ["previews"] as const,
    list: (envId: string, projectId: string) => [...previewKeys.all, "list", envId, projectId] as const,
    config: (envId: string, projectId: string) => [...previewKeys.all, "config", envId, projectId] as const,
    projectApps: (projectId: string) =>
        [...previewKeys.all, "projectApps", projectId] as const,
};

// ─── useProjectApps — all microservices in the project ──────────────────────

export function useProjectApps(projectId: string) {
    return useQuery<DeployedAppInfo[]>({
        queryKey: previewKeys.projectApps(projectId),
        queryFn: async () => {
            const { data: { microservices } } = await getKubeService().getMicroservices(projectId);
            return (microservices || []).map(m => ({
                name: m.name,
            }));
        },
        enabled: !!projectId,
        staleTime: DEPLOYED_APPS_STALE_TIME,
    });
}


